import { render, staticRenderFns } from "./ThgImpactSelectorCard.vue?vue&type=template&id=1e575eaf&scoped=true"
import script from "./ThgImpactSelectorCard.vue?vue&type=script&lang=ts"
export * from "./ThgImpactSelectorCard.vue?vue&type=script&lang=ts"
import style0 from "./ThgImpactSelectorCard.vue?vue&type=style&index=0&id=1e575eaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e575eaf",
  null
  
)

export default component.exports